import {
  ClipboardList, MessageSquare, ListChecks, Users, ShieldOff, Archive, HelpCircle
} from 'lucide-react';

// Rótulos legíveis pra cada tipo de ação registrada em logs_auditoria —
// compartilhado entre a página de Log de Auditoria e o widget de
// atividade recente do Dashboard. Precisa ficar em dia com todo `log(req,
// 'acao', ...)`/`LogAuditoria.registrar({acao, ...})` do backend — uma
// ação sem entrada aqui ainda aparece (fallback pro nome cru), só sem
// tradução amigável.
export const ACAO_LABEL = {
  // Enquetes dinâmicas
  criar_enquete: 'criou a enquete',
  atualizar_enquete: 'atualizou a enquete',
  remover_enquete: 'excluiu a enquete',
  desativar_enquete: 'desativou a enquete',
  reativar_enquete: 'reativou a enquete',
  enviar_imagem_capa: 'enviou a imagem de capa da enquete',
  remover_imagem_capa: 'removeu a imagem de capa da enquete',

  // Perguntas
  criar_pergunta: 'criou a pergunta',
  atualizar_pergunta: 'editou a pergunta',
  remover_pergunta: 'removeu a pergunta',
  enviar_imagem_pergunta: 'enviou imagem para a pergunta',
  remover_imagem_pergunta: 'removeu a imagem da pergunta',

  // Opções
  criar_opcao: 'adicionou a opção',
  atualizar_opcao: 'editou a opção',
  remover_opcao: 'removeu a opção',

  // Usuários do painel
  criar_usuario: 'criou o usuário',
  atualizar_usuario: 'editou os dados do usuário',
  desativar_usuario: 'desativou o usuário',
  reativar_usuario: 'reativou o usuário',
  resetar_senha_usuario: 'resetou a senha do usuário',
  alterar_senha_propria: 'alterou a própria senha',
  enviar_foto_usuario: 'enviou foto de perfil do usuário',
  remover_foto_usuario: 'removeu a foto de perfil do usuário',

  // IPs
  bloquear_ip: 'bloqueou o IP',
  desbloquear_ip: 'desbloqueou o IP',

  // Enquetes legadas (Portal de Entrada, Telão do Brasil)
  publicar_enquete_legado: 'tornou pública a enquete legada',
  despublicar_enquete_legado: 'tornou privada a enquete legada'
};

// Categoria (entidade) de cada ação — pra agrupar/filtrar por assunto em
// vez de por verbo. Enquete/pergunta/opção contam como uma categoria só
// ("Enquetes") já que na prática são sempre editadas juntas.
export const ENTIDADE_META = {
  enquete: { label: 'Enquetes', cor: 'bg-blue-50 text-blue-700', icon: ClipboardList },
  pergunta: { label: 'Enquetes', cor: 'bg-blue-50 text-blue-700', icon: MessageSquare },
  opcao: { label: 'Enquetes', cor: 'bg-blue-50 text-blue-700', icon: ListChecks },
  usuario: { label: 'Usuários', cor: 'bg-purple-50 text-purple-700', icon: Users },
  ip_bloqueado: { label: 'IPs', cor: 'bg-red-50 text-red-700', icon: ShieldOff },
  enquete_legado: { label: 'Enquetes legadas', cor: 'bg-amber-50 text-amber-700', icon: Archive }
};

export const ENTIDADE_META_PADRAO = { label: 'Outros', cor: 'bg-gray-100 text-gray-600', icon: HelpCircle };

// Rótulo legível pra cada chave que aparece dentro de `detalhes` (JSON
// gravado por log(req, ...)) — usado tanto no resumo compacto do card
// quanto no detalhamento completo do modal, pra nunca mostrar a chave crua
// (ex: "visibilidade_anterior") como se fosse a mensagem em si. Chave sem
// entrada aqui cai no fallback genérico (snake_case/camelCase → Capitalizado).
const CHAVE_DETALHE_LABEL = {
  titulo: 'Título',
  slug: 'Slug',
  descricao: 'Descrição',
  status: 'Status',
  visibilidade: 'Visibilidade',
  visibilidade_anterior: 'Visibilidade anterior',
  modo_resultado: 'Modo de resultado',
  data_encerramento: 'Data de encerramento',
  imagem_capa: 'Imagem de capa',
  imagem_path: 'Imagem',
  email: 'E-mail',
  nome_completo: 'Nome completo',
  nomeCompleto: 'Nome completo',
  tipo: 'Tipo',
  meta: 'Metadados do arquivo',
  motivo: 'Motivo',
  ip: 'IP',
  enquete: 'Enquete',
  tamanho: 'Tamanho (bytes)',
  nome_original: 'Nome original do arquivo',
  formato: 'Formato'
};

export function formatarChaveDetalhe(chave) {
  if (CHAVE_DETALHE_LABEL[chave]) return CHAVE_DETALHE_LABEL[chave];
  const espacado = chave.replace(/([a-z0-9])([A-Z])/g, '$1 $2').replace(/_/g, ' ');
  return espacado.charAt(0).toUpperCase() + espacado.slice(1);
}

// Valor pronto pra exibir numa única linha — null pra sinalizar "isso é um
// objeto/array, precisa de tratamento à parte" (ver DetalheLinha em
// DetalhesLogModal.js).
export function formatarValorDetalhe(valor) {
  if (valor === null || valor === undefined || valor === '') return '—';
  if (typeof valor === 'boolean') return valor ? 'Sim' : 'Não';
  if (Array.isArray(valor)) return valor.length ? valor.join(', ') : '—';
  if (typeof valor === 'object') return null;
  return String(valor);
}

export default ACAO_LABEL;
